const getDefaultState = () => {};

const state = getDefaultState();

const getters = {
  getStatusesForSelect: (state, getters, rootState) => process => {
    let usedStatuses = [];
    const currentProcessDummies = rootState.process.mars.dummies.dummies.filter(
      x => x.process == process
    );

    for (var i = 0; i < currentProcessDummies.length; i++) {
      usedStatuses.push(Number(currentProcessDummies[i].status_id));
    }

    return rootState.dictionary.responseStatuses
      .filter(x => x.id == 1 || x.id == 27 || x.id == 55896 || x.id == 55897 || x.id == 60498)
      .filter(x => !usedStatuses.includes(Number(x.id)))
      .map(x => {
        if (!x.is_hidden) {
          return { value: x.id, text: x.name };
        } else {
          return false;
        }
      });
  },

  getStatusNameById: (state, getters, rootState) => id => {
    const status = rootState.dictionary.responseStatuses.find(x => x.id == id);

    return status.name;
  }
};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
